(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icon-title-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // 0. Timeline Rail (single continuous dashed line)
    function updateTimelineRailForSection(sectionEl) {
      if (!sectionEl) return;
      const container = sectionEl.querySelector('.icon-title-card__mixed-content');
      const rail = sectionEl.querySelector('.icon-title-card__timeline-rail');
      if (!container || !rail) return;

      const circles = container.querySelectorAll('.timeline-circle');
      if (!circles || circles.length === 0) {
        rail.style.height = '0px';
        rail.style.display = 'none';
        return;
      }

      rail.style.display = 'block';

      const containerRect = container.getBoundingClientRect();
      const firstRect = circles[0].getBoundingClientRect();
      const lastRect = circles[circles.length - 1].getBoundingClientRect();

      const firstCenterY = (firstRect.top - containerRect.top) + (firstRect.height / 2);
      const lastCenterY = (lastRect.top - containerRect.top) + (lastRect.height / 2);
      const centerX = (firstRect.left - containerRect.left) + (firstRect.width / 2);

      // Extend a bit below the last circle so it can fade out smoothly.
      const extendPx = 160;
      const maxBottom = container.scrollHeight;
      const endY = Math.min(lastCenterY + extendPx, maxBottom);
      const height = Math.max(0, endY - firstCenterY);

      rail.style.top = `${firstCenterY}px`;
      rail.style.height = `${height}px`;
      container.style.setProperty('--timeline-rail-left', `${centerX}px`);
    }

    const iconTitleCards = document.querySelectorAll('.icon-title-card');
    iconTitleCards.forEach((sectionEl) => updateTimelineRailForSection(sectionEl));
    window.addEventListener('resize', () => {
      iconTitleCards.forEach((sectionEl) => updateTimelineRailForSection(sectionEl));
    });

    // 0b. YouTube embeds inside timeline blocks
    function extractYouTubeID(url) {
      if (!url) return null;
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = String(url).match(regExp);
      const id = match && match[2] ? match[2] : null;
      return id && id.length === 11 ? id : null;
    }

    function buildYouTubeEmbedUrl(videoId, autoplay) {
      const params = new URLSearchParams();
      params.set('rel', '0');
      params.set('modestbranding', '1');
      params.set('playsinline', '1');
      params.set('controls', '1');
      if (autoplay) {
        params.set('autoplay', '1');
        params.set('mute', '1');
        params.set('loop', '1');
        // YouTube loop requires playlist=id
        params.set('playlist', videoId);
      }
      return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
    }

    const youtubeHolders = document.querySelectorAll('.timeline-youtube');
    youtubeHolders.forEach((holder) => {
      const rawId = holder.getAttribute('data-video-id');
      const rawUrl = holder.getAttribute('data-youtube-url');
      const autoplay = holder.getAttribute('data-autoplay') === '1';
      const videoId = (rawId && rawId.trim().length === 11) ? rawId.trim() : extractYouTubeID(rawUrl);
      if (!videoId) return;

      holder.innerHTML = `<iframe class="timeline-youtube__iframe" src="${buildYouTubeEmbedUrl(videoId, autoplay)}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy" title="YouTube video"></iframe>`;
    });

    // 0c. FAQ Logic (icon-title-card FAQ blocks)
    function setFaqOpen(blockEl, shouldOpen) {
      const header = blockEl.querySelector('.icon-title-card__faq-header');
      const content = blockEl.querySelector('.icon-title-card__faq-content');
      if (!header || !content) return;

      if (shouldOpen) {
        blockEl.classList.add('is-active');
        header.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        blockEl.classList.remove('is-active');
        header.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0px';
      }
    }

    function initFaqInSection(sectionEl) {
      const faqBlocks = sectionEl.querySelectorAll('.icon-title-card__block-faq');
      if (!faqBlocks.length) return;

      // default: open first FAQ block in this section
      faqBlocks.forEach((b, idx) => setFaqOpen(b, idx === 0));

      faqBlocks.forEach((blockEl) => {
        const header = blockEl.querySelector('.icon-title-card__faq-header');
        if (!header) return;
        header.addEventListener('click', () => {
          const isActive = blockEl.classList.contains('is-active');
          // accordion behavior: only one open at a time
          faqBlocks.forEach((b) => setFaqOpen(b, b === blockEl ? !isActive : false));
        });
      });
    }

    const sections = document.querySelectorAll('.icon-title-card');
    // delay to ensure layout is ready for correct scrollHeight
    setTimeout(() => {
      sections.forEach((sectionEl) => initFaqInSection(sectionEl));
    }, 0);

    window.addEventListener('resize', () => {
      sections.forEach((sectionEl) => {
        const active = sectionEl.querySelectorAll('.icon-title-card__block-faq.is-active');
        active.forEach((blockEl) => {
          const content = blockEl.querySelector('.icon-title-card__faq-content');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        });
      });
    });

    // 1. Email Link Handling
    const container = document.querySelectorAll('.icon-title-card__text, .icon-title-card__item-text');
    container.forEach(function(el) {
      const links = el.querySelectorAll('a');
      links.forEach(function(link) {
        const text = link.textContent.trim();
        const href = link.getAttribute('href');
        if (text.includes('@') && href && !href.startsWith('mailto:')) {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (emailPattern.test(text)) {
            link.setAttribute('href', 'mailto:' + text);
          }
        }
      });
    });

    // 2. Mobile Accordion Logic - REMOVED per user request
    /*
    const accordionHeaders = document.querySelectorAll('.icon-title-card__item-header');
    
    if (window.innerWidth < 750) {
      const firstCard = document.querySelector('.icon-title-card__item');
      if (firstCard) {
        firstCard.classList.add('is-active');
      }
    }

    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        if (window.getComputedStyle(this.querySelector('.icon-title-card__accordion-icon')).display === 'none') {
           return;
        }
        const item = this.parentElement;
        item.classList.toggle('is-active');
      });
    });
    */

    // 3. Newsletter Logic
    const forms = document.querySelectorAll('.newsletter-form');
    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const blockId = form.id.replace('newsletter-form-', '');
        const emailInput = document.getElementById(`newsletter-email-${blockId}`);
        const successMsg = document.getElementById(`newsletter-success-${blockId}`);
        const errorMsg = document.getElementById(`newsletter-error-${blockId}`);
        const btn = form.querySelector('button');
        
        // Basic loading state
        btn.disabled = true;
        const originalText = btn.querySelector('.button-text').textContent;
        btn.querySelector('.button-text').textContent = 'Sending...';

        try {
          // Simulate API call or replace with actual Mailchimp fetch
          // const response = await fetch(...);
          
          await new Promise(resolve => setTimeout(resolve, 1000)); // Fake delay

          // Success
          // form.style.display = 'none'; // Keep form visible
          successMsg.style.display = 'flex';
          
          // Hide success message after 5 seconds
          setTimeout(() => {
            successMsg.style.display = 'none';
          }, 5000);
          
          // Reset button
          btn.disabled = false;
          btn.querySelector('.button-text').textContent = originalText;
          
          // Clear input if needed, or leave it
          // emailInput.value = ''; 
        } catch (err) {
          errorMsg.textContent = 'Error subscribing. Please try again.';
          errorMsg.style.display = 'block';
          btn.disabled = false;
          btn.querySelector('.button-text').textContent = originalText;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
